import { TCustomDashboardSourceType } from 'src/models/customDashboard';

export const getSourceTypeLabel = (sourceType: TCustomDashboardSourceType) => {
  switch (sourceType) {
    case 'socmed':
      return 'Social Media';
    case 'onm':
      return 'Online News';
    case 'ofm':
      return 'Print & Broadcast Media';
  }
};
